import React, { Component } from 'react'

import { connect } from 'react-redux'



import { Redirect, RouteComponentProps } from 'react-router-dom'



import { ThunkDispatch } from 'redux-thunk'

import { RootState } from '../../store';

import { IUserSate } from '../../store/user/reducers';

import { loginUser, isUserValid, UserApi } from '../../store/user/actions';

import { SeasonPreviewLoginLayout } from 'molo-shared/lib/seasonPreview';



type AuthView = 'login' | 'forgot' | 'forgot-sent';



interface RouteProps extends RouteComponentProps {}



interface State {

    formValues: {

        email: string

        password: string,

    },

    redirectToReferrer: boolean,

    authView: AuthView,

    isSubmittingForgot: boolean,

}

  

interface OwnProps {

    location: any

}

  

interface DispatchProps {

    loginUser: (email: string, password: string) => void;

    isUserValid: () => void;

}

  

interface StateProps {

    userState: IUserSate

}

  

type Props = StateProps & OwnProps & DispatchProps & RouteProps;



export class Login extends Component<Props, State> {

    state: State = {

        formValues: {email: '', password: ''},

        redirectToReferrer: false,

        authView: 'login',

        isSubmittingForgot: false,

    }



    componentDidMount() {

        if(this.props.userState.isValidated && this.props.userState.user) {

            this.setState({ redirectToReferrer: true });

        }



        const locationState = this.props.location.state;

        if (locationState && locationState.authView === 'forgot') {

            this.setState({ authView: 'forgot' });

        }

    }



    UNSAFE_componentWillReceiveProps(nextProps: Props) {

        if (nextProps.userState.user) {

            this.setState({ redirectToReferrer: true });

        }



        if (nextProps.userState.token && !nextProps.userState.user) {

            this.props.isUserValid();

        }

    }



    private handleChange = (e: React.FormEvent<HTMLInputElement>) => {

        const { name, value } = e.currentTarget;



        if (name === 'email') {

            this.setState({formValues: {email: value, password: this.state.formValues.password}})

        }



        if (name === 'password') {

            this.setState({formValues: {email: this.state.formValues.email, password: value}})

        }

    };



    handleSubmit = () => {

        this.props.loginUser(this.state.formValues.email, this.state.formValues.password)

    }



    handleForgotSubmit = async () => {

        if (this.state.isSubmittingForgot) {

            return;

        }



        this.setState({ isSubmittingForgot: true });



        try {

            await UserApi.resetPassword(this.state.formValues.email);

            this.setState({ authView: 'forgot-sent', isSubmittingForgot: false });

        } catch (_err) {

            this.setState({ isSubmittingForgot: false });

        }

    }



    showForgotView = () => {

        this.setState({ authView: 'forgot' });

    }



    showLoginView = () => {

        this.setState({ authView: 'login', isSubmittingForgot: false });

    }



    renderFooterLink = () => {

        const { authView } = this.state;



        if (authView === 'login') {

            return (

                <button

                    type="button"

                    className="login-form__footer-link login-page__forgot-password"

                    onClick={this.showForgotView}

                >

                    Forgot password?

                </button>

            );

        }



        if (authView === 'forgot' || authView === 'forgot-sent') {

            return (

                <button

                    type="button"

                    className="login-form__footer-link login-form__back"

                    onClick={this.showLoginView}

                >

                    Back to sign in

                </button>

            );

        }



        return null;

    }



    renderLoginPanel = () => (

        <>

            <input

                className="login-form__form-control__input"

                name="email"

                type="email"

                autoComplete="username"

                placeholder="Your email"

                value={this.state.formValues.email}

                onChange={this.handleChange}

                required

            />

            <input

                className="login-form__form-control__input"

                name="password"

                type="password"

                autoComplete="current-password"

                placeholder="Your password"

                value={this.state.formValues.password}

                onChange={this.handleChange}

                required

            />

            <button

                type="submit"

                className="login-form__form-control__btn"

            >

                Sign in

            </button>

        </>

    )



    renderForgotPanel = () => (

        <>

            <h2 className="login-form__title">Reset password</h2>

            <p className="login-form__lead">We&apos;ll send you an email with your new password.</p>

            <input

                className="login-form__form-control__input"

                name="email"

                type="email"

                autoComplete="username"

                placeholder="Your email"

                value={this.state.formValues.email}

                onChange={this.handleChange}

                required

            />

            <button

                type="submit"

                className="login-form__form-control__btn"

                disabled={this.state.isSubmittingForgot}

            >

                {this.state.isSubmittingForgot ? 'Sending…' : 'Reset password'}

            </button>

        </>

    )



    renderForgotSentPanel = () => (

        <>

            <h2 className="login-form__title">Check your email</h2>

            <p className="login-form__lead">We have sent you an email with a new password.</p>

            <button

                type="button"

                className="login-form__form-control__btn"

                onClick={this.showLoginView}

            >

                Back to sign in

            </button>

        </>

    )



    renderPanel = () => {

        const { authView } = this.state;



        if (authView === 'forgot') {

            return this.renderForgotPanel();

        }



        if (authView === 'forgot-sent') {

            return this.renderForgotSentPanel();

        }



        return this.renderLoginPanel();

    }



    render() {

        const locationState = this.props.location.state;

        const referer = (locationState && locationState.referer) || '/';

        const { redirectToReferrer, authView } = this.state;



        if (redirectToReferrer) {

            return <Redirect to={referer} />;

        }



        return (

            <SeasonPreviewLoginLayout>

                <section className="login-form">

                    <form

                        className="login-form__fields"

                        onSubmit={(e) => {

                            e.preventDefault();



                            if (authView === 'forgot') {

                                this.handleForgotSubmit();

                                return;

                            }



                            if (authView === 'login') {

                                this.handleSubmit();

                            }

                        }}

                    >

                        <div className="login-form__panel">

                            <div key={authView} className="login-form__panel-body">

                                {this.renderPanel()}

                            </div>

                            <div key={`footer-${authView}`} className="login-form__panel-footer">

                                {this.renderFooterLink()}

                            </div>

                        </div>

                    </form>

                </section>

            </SeasonPreviewLoginLayout>

        )

    }

}



const mapStateToProps = (states: RootState, ownProps: OwnProps): StateProps => {

    return {

      userState: states.user.user

    }

}



const mapDispatchToProps = (dispatch: ThunkDispatch<{}, {}, any>, ownProps: OwnProps): DispatchProps => {

    return {

        loginUser: async (email: string, password: string) => {

            await dispatch(loginUser(email, password))

        },

        isUserValid: async () => {

            await dispatch(isUserValid())

        },

    }

}



export default connect(mapStateToProps, mapDispatchToProps)(Login)


